import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

const STEPS = [
    { num: "01", title: "Join", desc: "Enter the ecosystem with a one-time joining amount of 5 USDT (BEP20)." },
    { num: "02", title: "Build", desc: "Participate through the 7-level affiliate structure and the 12-slot matrix system." },
    { num: "03", title: "Grow", desc: "Develop your matrix levels and grow your community across the network." },
    { num: "04", title: "Expand", desc: "Grow alongside the broader Nexora ecosystem and its future products." },
];

export const HowItWorks = () => {
    const { t } = useLanguage();
    return (
        <section id="how-it-works" data-testid="how-it-works-section" className="border-t border-white/5 bg-nx-base py-20 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
                <SectionHeader
                    index="02"
                    label={t("How It Works")}
                    testId="how-it-works"
                    title={<>{t("Four Stages.")}<br />{t("One System.")}</>}
                    description={t("A transparent, smart-contract powered structure — the same fixed formula for every member.")}
                />
                <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/5 bg-white/5 sm:grid-cols-2 lg:grid-cols-4">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.num} delay={i * 0.08} className="h-full">
                            <div className="flex h-full flex-col bg-nx-elev p-7 lg:p-8" data-testid={`step-${s.num}`}>
                                <span className="text-4xl font-extrabold tracking-tight text-white/10 tabular">{s.num}</span>
                                <span className="mt-6 h-px w-10 bg-nx-lime/60" aria-hidden="true" />
                                <h3 className="mt-4 text-base font-extrabold uppercase tracking-[0.14em] text-nx-text">{t(s.title)}</h3>
                                <p className="mt-2.5 text-sm leading-relaxed text-nx-sub">{t(s.desc)}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
